import React, { Component } from 'react';

import PropTypes from 'prop-types';

import Tooltip from 'rc-tooltip';

export default class UserRanking extends Component {
  computeScore = () => {
    const { scores } = this.props;

    const score =
      scores.reduce((prev, cur) => {
        return prev + parseInt(cur.score, 10);
      }, 0) / scores.length;

    if (score >= 5 && score < 10) return { grade: 'F', color: 'red' };
    else if (score >= 10 && score < 20) return { grade: 'D', color: 'orange' };
    else if (score >= 20 && score < 30)
      return { grade: 'C', color: 'goldenrod' };
    else if (score >= 30 && score < 40) return { grade: 'B', color: 'blue' };
    else if (score >= 40 && score < 50) return { grade: 'A', color: 'green' };
    else if (score >= 50) return { grade: 'A+', color: 'green' };
    else
      return {
        grade: 'No Scoring Data Available',
        color: 'rgb(112, 112, 112)',
        size: 14,
        hideTooltip: true,
        fontWeight: 700,
      };
  };

  organizeData = () => {
    const { scores } = this.props;

    return scores.reduce(
      (prev, cur) => {
        const penalties = Object.keys(cur.data.penalties);
        const bonuses = Object.keys(cur.data.bonuses);

        penalties.forEach(penalty => {
          const count = prev.deductions[penalty] || 0;

          prev.deductions[penalty] = count + 1;
        });

        bonuses.forEach(bonus => {
          const count = prev.bonuses[bonus] || 0;

          prev.bonuses[bonus] = count + 1;
        });

        return prev;
      },
      {
        bonuses: {},
        deductions: {},
      },
    );
  };

  renderData = data => {
    const list = Object.keys(data).reduce((prev, cur, k) => {
      prev.push(
        <li key={`${cur}-${k}`}>
          {cur} - {data[cur]} task{data[cur] <= 1 ? '' : 's'}
        </li>,
      );

      return prev;
    }, []);

    return list;
  };

  computeLayout = (data, type) => {
    if (!Object.keys(data).length) return null;

    return (
      <div>
        <div>{type}</div>
        <ul>{this.renderData(data)}</ul>
      </div>
    );
  };

  tooltipLayout = () => {
    const data = this.organizeData();

    const deductionsLayout = this.computeLayout(data.deductions, 'Deductions');
    const bonusesLayout = this.computeLayout(data.bonuses, 'Bonuses');

    if (!deductionsLayout && !bonusesLayout) {
      return <div>Everything is on Schedule</div>;
    }

    return (
      <div>
        {deductionsLayout}
        {bonusesLayout}
      </div>
    );
  };

  tooltipRender = (display, grade, style) => {
    const gradeDiv = <span style={style}>{grade}</span>;

    if (!display) {
      return (
        <Tooltip placement="right" overlay={this.tooltipLayout()}>
          {gradeDiv}
        </Tooltip>
      );
    } else {
      return gradeDiv;
    }
  };

  render() {
    const score = this.computeScore();
    const display = score.hideTooltip || false;

    return (
      <div
        style={{
          display: 'flex',
          flex: 'none', // setting this to flex: 1 
          padding: '0.50rem 0.75rem',
          border: '1px solid rgba(0,0,0,0.125)',
        }}
      >
        {this.tooltipRender(display, score.grade, {
          color: score.color,
          fontSize: score.size || 35,
          fontWeight: score.fontWeight || 500,
        })}
      </div>
    );
  }
}

UserRanking.propTypes = {
  scores: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/UserRanking/UserRanking.js